import { SvgProps } from "components/icons/types";

export const Speedometer = (props: SvgProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 10.1666L11.3333 7.83325"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.94841 13.0833C3.43638 12.1965 3.16679 11.1906 3.16675 10.1666C3.16671 9.14257 3.43622 8.13662 3.94819 7.2498C4.46016 6.36299 5.19656 5.62657 6.08335 5.11456C6.97014 4.60256 7.97609 4.33301 9.00008 4.33301C10.0241 4.33301 11.03 4.60256 11.9168 5.11456C12.8036 5.62657 13.54 6.36299 14.052 7.2498C14.5639 8.13662 14.8335 9.14257 14.8334 10.1666C14.8334 11.1906 14.5638 12.1965 14.0517 13.0833"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
